// extracted by mini-css-extract-plugin
export var cartIcon = "_li-0";
export var cartIconContainer = "_li-1";